<template>
  <item-nav :id="$attrs['id']">
    <item-nav-item :label="$t('layout.nav.admin.taxSetNav.overview')" link="taxSets" />
    <item-nav-group v-if="!isEmpty(taxSets)" :open="true" :label="$t('layout.nav.admin.taxSetNav.taxSets')">
      <template v-for="taxSet in taxSets" v-if="!taxSet.deleted">
        <item-nav-group-item :label="taxSet.name || '-'" :params="routeParams(taxSet.id)" :key="taxSet.id" link="taxSet" />
      </template>
    </item-nav-group>

    <item-nav-group v-if="!isEmpty(deletedTaxSets)" :label="$t('layout.nav.admin.taxSetNav.deletedTaxSets')">
      <item-nav-group-item v-for="taxSet in deletedTaxSets"
                           :label="taxSet.name || '-'"
                           :params="routeParams(taxSet.id)"
                           :key="taxSet.id"
                           link="taxSet" />
    </item-nav-group>

  </item-nav>
</template>

<script>

import { cloneDeep, isNil, isEmpty, keyBy, sortBy } from 'lodash';
import ItemNavGroup from '../ItemNavGroup';
import ItemNavGroupItem from '../ItemNavGroupItem';
import HotelmeisterMixin from '../../../../../mixins/HotelmeisterMixin';
import HotelSettingsMixin from '../../../../../mixins/HotelSettingsMixin';

export default {
  name: 'TaxSetNav',
  components: { ItemNavGroupItem, ItemNavGroup },

  mixins: [HotelmeisterMixin],
  props: [],

  data() {
    return {
      taxSets: [],
    };
  },

  computed: {
    deletedTaxSets: function () {
      return this.taxSets.filter(it => it.deleted === true);
    },
  },

  created: function () {
    this.updateTaxSets();

    this.$serviceBus.$on('taxSet.list', (data) => {
      if (isNil(data)) {
        this.updateTaxSets();
      } else {
        this.taxSets = sortBy(data, ['name']);
      }
    });
  },

  mounted: function () {
    this.$emit('widenav', true);
  },

  methods: {
    updateTaxSets() {
      this.axios.get(this.serviceUrls.taxSet.list(this))
        .then((response) => {
          this.taxSets = sortBy(response.data.data, ['name']);
        });
    },
    routeParams(taxSetId) {
      return {
        taxSetId: taxSetId,
      };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // @import '~styles/main';
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/admin/TaxSetNav.vue